(function (ws) {
    'use strict';

    ws.models.outstandingStock = Backbone.Model.extend({
        defaults: {
            sapAvailabilityList: [{
                stockLevel: '',
                onOrderAvailability: '',
                vendorLeadTime: '',
                onOrderDate: '',
                slocAvailability: '',
                isIntangible: '',
                isCustomerInventory: ''
            }],
            futureAvailabilityCount: 0,
            maxAvailabilityRows: 0
        },

        /**
         * Gets max row count of sapAvailabilityList
         * @param {Object} data
         * @returns {integer} maxRows
         */
        getMaxRowCount: function (data) {
            var maxObj = _.max(data, function(availability) {
                return (availability.futureAvailability && availability.futureAvailability.length) || 0;
            });

            return (maxObj.futureAvailability && maxObj.futureAvailability.length) || 0;
        },

        /**
         * Returns number of sapAvailabilityList items that has futureAvailability items inside
         * @param {Object} data
         * @returns {integer} futureAvailabilityCount
         */
        hasFutureAvailability: function(data) {
            return _.reduce(data, function (memo, sapData) {
                var futureAvailabilityCount = sapData.futureAvailability && sapData.futureAvailability.length;
                return memo + (futureAvailabilityCount ? 1 : 0);
            }, 0);
        },

        /**
         * Returns number of sapAvailabilityList items that have isCustomerInventory atttribute true
         * @param {Object} data
         * @returns {integer} isCustomerInventoryCount
         */
        hasCustomerStock: function(data) {
            return _.reduce(data, function (memo, sapData) {
                return memo + (sapData.isCustomerInventory ? 1 : 0);
            }, 0);
        }
    });
})(westcon);
